import { Component, OnInit, VERSION, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { EleicaoService } from 'src/app/services/eleicao.service'
import { CargoService } from 'src/app/services/cargo.service'
import { CargoNew } from 'src/app/models/cargonew.model'
import { Eleicao } from 'src/app/models/eleicao.model';
import { NgxSpinnerService } from 'ngx-spinner'
import { CargoCsvDTO } from 'src/app/models/cargoCsvDTO.model';
import { CargoComponent } from 'src/app/pages/gestor/parametrizacoes/cargo/cargo.component'
import { Utils } from 'src/app/utils/utils';

@Component({
  selector: 'cadastro-massa-cargo',
  templateUrl: './cargo-csv-import.component.html',
  styleUrls: ['./cargo-csv-import.component.css']
})

export class CargoCsvComponent implements OnInit {
  formCadastroCargos: FormGroup;
  idEleicao: any;
  token: any;
  listaCargos: any;
  eleicao: any;
  editandoCargo: boolean = false; // status para definir se o formulário está editando o Cargo ou não (troca de botão e action).
  idCargoEditando: any;

  public cargosCsv: CargoCsvDTO[] = [];
  newCargosArray: CargoCsvDTO[] = [];
  cargosCriticados: any = [];
  cargosEnviados: any = [];
  cargosDuplicados: any = [];
  cargosSemPlano: any = [];
  ativaNavValidacao: boolean = false;
  ativaNavEnviar: boolean = false;
  ativaNavEnviados: boolean = false;
  ativaNavDuplicados: boolean = false;
  ativaNavSemPlano: boolean = false;
  temPlanos: boolean = false;

  @ViewChild('closeModal', {static:false}) childModal: any;
  constructor(
    public eleicaoService: EleicaoService,
    public cargoService: CargoService,
    protected messageService: MessageService,
    public spinner: NgxSpinnerService,
    public utils: Utils,
    public abe: CargoComponent
  ) { }

  async ngOnInit() {
    this.spinner.show();
    this.idEleicao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao")).id;
    this.eleicao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao"));
    this.temPlanos = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao")).temPlanos;
    this.token = sessionStorage.getItem("token");
    this.formCadastroCargos = new FormGroup({
      nome: new FormControl(),
      quantidadeEleitos: new FormControl()
    })
  }
  // CSV ////////////////////////////////////////////////////
  importarCsv(event){
    this.zerarInputFile();
    let arquivos = event.srcElement.files;
    if(this.validaTipoArquivo(arquivos[0])) {
      let input = event.target;
      let fileReader = new FileReader();
      fileReader.readAsText(input.files[0]);
      
      fileReader.onload = () => {
        let csvData = fileReader.result;
        let csvRecordsArray = csvData.toString().split(/\r\n|\n/);
        let headersRow = this.utils.getHeaderArray(csvRecordsArray);
        this.cargosCsv = this.getDataRecordsArrayFromCSVFile(csvRecordsArray, headersRow.length);
        this.cargosCsvParaNovosCargosDTO(this.cargosCsv);
        this.validaNavTab();
      };
    } else {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: 'O arquivo selecionado não é um .csv válido!' });
      this.cargosCsv = [];
    }
  }

  validaTipoArquivo(file: any) {
    return file.name.endsWith(".csv");
  }

  getDataRecordsArrayFromCSVFile(csvRecordsArray: any, headerLength: any) {
    let csvArr = [];

    for (let i = 1; i < csvRecordsArray.length; i++) {
      let curruntRecord = csvRecordsArray[i].split(';');
      if (curruntRecord.length == headerLength) {
        let cargoCsv: CargoCsvDTO = new CargoCsvDTO();
        cargoCsv.nome = curruntRecord[0].trim();
        cargoCsv.informacao = curruntRecord[1].trim();
        cargoCsv.labelCargo = curruntRecord[2].trim();
        cargoCsv.qtdElegiveis = +curruntRecord[3].trim();
        cargoCsv.plano = curruntRecord[4].trim().replace(/(^"|"$)/g, '');
        cargoCsv.agrupador = curruntRecord[5].trim().replace(/(^"|"$)/g, '');
        cargoCsv.eleicao = {"id": this.idEleicao};
        csvArr.push(cargoCsv);
      }
    }
    
    return csvArr;
  }

  cargosCsvParaNovosCargosDTO(cargosCsv: CargoCsvDTO[]) {
    for(let cargo of cargosCsv) {
      let novoCargo: CargoCsvDTO = new CargoCsvDTO();
      novoCargo.nome = cargo.nome;
      novoCargo.informacao = cargo.informacao;
      novoCargo.labelCargo = cargo.labelCargo;
      novoCargo.qtdElegiveis = cargo.qtdElegiveis;
      novoCargo.plano = cargo.plano;
      novoCargo.agrupador = cargo.agrupador;
      novoCargo.eleicao = cargo.eleicao;

      if (!novoCargo.nome || novoCargo.nome == ""){
        this.cargosCriticados.push({ novoCargo, critica: "Validação 1" });
      } else if (!novoCargo.qtdElegiveis || novoCargo.qtdElegiveis < 1) {
        this.cargosCriticados.push({ novoCargo, critica: "Validação 2" });
      }else if(!novoCargo.labelCargo || novoCargo.labelCargo  == "") {
        this.cargosCriticados.push({ novoCargo, critica: "Validação 3" });
      }else if (this.temPlanos && ((!novoCargo.plano || novoCargo.plano == "") || (!novoCargo.agrupador || novoCargo.agrupador == ""))) {
        this.cargosSemPlano.push(novoCargo);
      }else {
        this.newCargosArray.push(novoCargo);
      }
    }
  }
  
  private async insercaoEmMassa(cargos: CargoCsvDTO[]) {
    await this.cargoService.insercaoEmMassaCargos(cargos, this.token).then((resp: any) => {
      this.cargosEnviados = resp.enviados;
      this.cargosDuplicados = resp.duplicados;
      this.newCargosArray = [];
      this.validaNavTabAposSalvar();
      if (this.cargosEnviados.length > 0) {
        this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso', detail: 'Cargos enviados com sucesso!' });
        setTimeout(function () {
          window.location.reload();
        })
      }
    }, error => {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: error });
    });
  }

  zerarInputFile(element?){
    if (element) {
      element.value = '';
    }
    this.newCargosArray = [];
    this.cargosCriticados = [];
    this.cargosDuplicados = [];
    this.cargosEnviados = [];
    this.cargosSemPlano = [];
  }

  importarList(){
    if (this.newCargosArray.length > 0){
      if (this.cargosEnviados.length > 0) {
        this.cargosEnviados = [];
      }
      if (this.cargosDuplicados.length > 0) {
        this.cargosDuplicados = [];
      }
      this.insercaoEmMassa(this.newCargosArray);
    } else {
      this.childModal.nativeElement.click();
    }
  }

  validaNavTab() {
    if (this.cargosCriticados.length > 0 && this.cargosDuplicados.length == 0 && this.cargosEnviados.length == 0) {
      this.ativaNavValidacao = true;
    } else {
      this.ativaNavValidacao = false;
    }

    if (this.cargosCriticados.length == 0 && this.newCargosArray.length > 0) {
      this.ativaNavEnviar = true;
    } else {
      this.ativaNavEnviar = false;
    }

    if (this.cargosSemPlano.length > 0 && this.cargosCriticados.length == 0) {
      this.ativaNavSemPlano = true;
      this.ativaNavEnviar = false;
    } else {
      this.ativaNavSemPlano = false;
    }

  }

  validaNavTabAposSalvar() {
    if (this.cargosDuplicados.length > 0) {
      this.ativaNavDuplicados = true;
      this.ativaNavValidacao = false;
      this.ativaNavEnviar = false;
    } else {
      this.ativaNavDuplicados = false;
    }

    if (this.cargosDuplicados.length == 0 && this.cargosEnviados.length > 0) {
      this.ativaNavEnviados = true;
      this.ativaNavValidacao = false;
      this.ativaNavEnviar = false;
    } else {
      this.ativaNavEnviados = false;
    }

    if (this.cargosSemPlano.length > 0) {
      this.ativaNavSemPlano = true;
    } else {
      this.ativaNavSemPlano = false;
    }
  }

  salvarCargosSemPlano(){
    for (let cargo of this.cargosSemPlano) {
      this.newCargosArray.push(cargo);
    }
    this.cargosSemPlano = [];
    this.ativaNavSemPlano = false;
    this.ativaNavEnviar = true;
  }

}
